import { memo } from "react";

export default memo(function CardCategory({
  style,
  isActive,
  name,
  index,
  total,
  onClick,
  isSelected,
}) {
  return (
    <div
      className={`card-category${isActive ? " active" : ""}${isSelected ? " selected" : ""}`}
      onClick={() => onClick(name)}
      style={style}
    >
      <p className="name">{name}</p>
      {name !== "All" ? <p className="total">{total}</p> : null}
    </div>
  );
});
